import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import { firestorePlugin } from 'vuefire';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Toaster from 'v-toaster';
import 'v-toaster/dist/v-toaster.css'
import vuescroll from 'vuescroll';

Vue.use(vuescroll);
Vue.use(firestorePlugin);
Vue.config.productionTip = false;
Vue.use(Toaster, {timeout: 5000});

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
